import types from '../mutation-types';
import CandidatesAPI from '../../api/candidates';

export const state = {
  records: [],
  jobs: [],
  selected: [],
  meta: {
    total: 0,
    elegiveis: 0,
    jaConvidados: 0,
    // null, não 0: antes da primeira resposta não sabemos o consumo do dia, e
    // "hoje já foram 0 de 200" numa tela cujo propósito é conter volume é uma
    // afirmação falsa sobre cota. A tela esconde o número enquanto for null.
    enviadosHoje: null,
    tetoDiario: 200,
  },
  uiFlags: { isFetching: false, isDispatching: false },
};

export const getters = {
  getCandidates: $state => $state.records,
  getCandidateJobs: $state => $state.jobs,
  getSelectedCandidates: $state =>
    $state.records.filter(r => $state.selected.includes(r.key)),
  getCandidateMeta: $state => $state.meta,
  getCandidateUIFlags: $state => $state.uiFlags,
};

export const actions = {
  async fetchJobs({ commit }) {
    commit(types.SET_CANDIDATE_UI_FLAG, { isFetching: true });
    try {
      const { data } = await CandidatesAPI.jobs();
      commit(types.SET_CANDIDATE_JOBS, data.vagas ?? []);
    } finally {
      commit(types.SET_CANDIDATE_UI_FLAG, { isFetching: false });
    }
  },

  // A seleção morre junto com a lista: manter marcado alguém da vaga anterior
  // dispararia para a pessoa errada.
  //
  // No erro, a lista antiga também morre. Senão o seletor mostra a vaga B e a
  // tabela lista as pessoas da vaga A, sem aviso — a tela mentindo é pior que a
  // tela vazia. A exceção sobe para a página poder alertar.
  async fetchCandidates({ commit }, vaga) {
    commit(types.SET_CANDIDATE_UI_FLAG, { isFetching: true });
    commit(types.CLEAR_CANDIDATE_SELECTION);
    try {
      const { data } = await CandidatesAPI.list(vaga);
      commit(types.SET_CANDIDATES, data);
    } catch (error) {
      commit(types.SET_CANDIDATES, {});
      throw error;
    } finally {
      commit(types.SET_CANDIDATE_UI_FLAG, { isFetching: false });
    }
  },

  // Devolve a resposta para a página poder mostrar os recusados pelo teto — o
  // recusado nunca some em silêncio (§4.4 da spec). Só limpa a seleção no
  // sucesso: se o disparo falhou, o agente ainda precisa dela para repetir.
  async dispatchInvites({ commit }, payload) {
    commit(types.SET_CANDIDATE_UI_FLAG, { isDispatching: true });
    try {
      const { data } = await CandidatesAPI.dispatch(payload);
      commit(types.CLEAR_CANDIDATE_SELECTION);
      return data;
    } finally {
      commit(types.SET_CANDIDATE_UI_FLAG, { isDispatching: false });
    }
  },

  toggleCandidate({ commit }, key) {
    commit(types.TOGGLE_CANDIDATE, key);
  },

  setSelection({ commit }, keys) {
    commit(types.SET_SELECTED_CANDIDATES, keys);
  },

  clearSelection({ commit }) {
    commit(types.CLEAR_CANDIDATE_SELECTION);
  },
};

export const mutations = {
  // O contrato do C1 é camelCase — conferido contra a rota no ar em 05/08:
  // raiz { vaga, total, elegiveis, jaConvidados, enviadosHoje, tetoDiario,
  // candidatos[] }. Ler um nome só é deliberado: aceitar snake_case junto
  // esconderia o dia em que o C1 mudasse de forma.
  [types.SET_CANDIDATES]($state, data) {
    $state.records = data.candidatos ?? [];
    $state.meta = {
      ...$state.meta,
      total: data.total ?? 0,
      elegiveis: data.elegiveis ?? 0,
      jaConvidados: data.jaConvidados ?? 0,
      // Estes dois a API manda; o fallback existe só para a resposta de erro
      // (SET_CANDIDATES com {}) não zerar o cabeçalho e anunciar "0 de 200".
      enviadosHoje: data.enviadosHoje ?? $state.meta.enviadosHoje,
      tetoDiario: data.tetoDiario ?? $state.meta.tetoDiario,
    };
  },
  [types.SET_CANDIDATE_JOBS]($state, jobs) {
    $state.jobs = jobs;
  },
  [types.TOGGLE_CANDIDATE]($state, key) {
    $state.selected = $state.selected.includes(key)
      ? $state.selected.filter(k => k !== key)
      : [...$state.selected, key];
  },
  [types.SET_SELECTED_CANDIDATES]($state, keys) {
    $state.selected = keys;
  },
  [types.CLEAR_CANDIDATE_SELECTION]($state) {
    $state.selected = [];
  },
  [types.SET_CANDIDATE_UI_FLAG]($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
};

export default { namespaced: true, state, getters, actions, mutations };
